import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import { useUser } from '../../context/UserContext';
import { Link } from 'react-router-dom';

const ActiveCheckpoints = () => {
    const [checkpoints, setCheckpoints] = useState([]);
    const { logout, hasPermission } = useUser();
	const canEdit = hasPermission("checkpoints", "edit");

    useEffect(() => {
        fetchActiveCheckpoints();
    }, []);

    const fetchActiveCheckpoints = async () => {
        try {
            const res = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/checkpoints`,
                { method: 'GET' },
                logout
            );
            const data = await res.json();
            const activeCheckpoints = data.filter(checkpoint => checkpoint.isActive);
            setCheckpoints(activeCheckpoints);
        } catch (error) {
            console.error('Ошибка загрузки КПП:', error);
        }
    };

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-[#CCCCCC]">Активные КПП</h2>
                <Link
                    to="/checkpoints"
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
                >
                    Управление КПП
                </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {checkpoints.map(checkpoint => (
                    <div
                        key={checkpoint._id}
                        className="bg-[#252526] p-4 rounded-lg border border-[#3E3E42]"
                    >
                        <h3 className="text-xl font-semibold mb-2 text-[#CCCCCC]">
                            {checkpoint.name}
                        </h3>
                        <p className="text-gray-400 mb-2">{checkpoint.description}</p>
                        <p className="text-gray-400 mb-2">Локация: {checkpoint.location}</p>
                        <p className="text-gray-400 mb-4">
                            Тип: {checkpoint.type === 'entry' ? 'Вход' : 'Выход'}
                        </p>
                        {canEdit && <Link
                            to={`/checkpoint/${checkpoint._id}`}
                            className="w-full bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded block text-center"
                        >
                            Открыть верификацию
                        </Link>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ActiveCheckpoints; 